const BASE_URL = process.env.REACT_APP_BASE_URL;

async function request(url, options = {}) {
  const token = localStorage.getItem("token"); // Or from Redux/Context


  let headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  // If the body is FormData, don't set Content-Type (browser will handle it)
  const isFormData = options.body instanceof FormData;

  // console.log ("::::::::::::::::::::::::",isFormData);
  if (!isFormData && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  // headers['X-Dev-Bypass'] = 'true';
  // headers['X-Dev-User-Id'] = '23';
  // headers['X-Dev-User-Id'] = '6693019';
  // headers['X-Dev-User-Id'] = '37';

  try {
    const response = await fetch(BASE_URL + url, {
      ...options,
      headers,
    });

    // Handle non-OK responses
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Error: ${response.status}`);
    }

    // Return JSON if available
    const contentType = response.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    }

    return await response.text(); // fallback for non-JSON
  } catch (error) {
    console.error("HTTP Error:", error.message);
    throw error;
  }

}

// Reusable helpers
export const http = {
  get: (url, options) => request(url, { method: "GET", ...options }),
  post: (url, body, options) =>
    request(url, { method: "POST", body: JSON.stringify(body), ...options }),
  postFormData: (url, body, options) =>
    request(url, { method: "POST", body: body, ...options }),

  put: (url, body, options) =>
    request(url, { method: "PUT", body: JSON.stringify(body), ...options }),
  patch: (url, body, options) =>
    request(url, { method: "PATCH", body: JSON.stringify(body), ...options }),
  delete: (url, options) => request(url, { method: "DELETE", ...options }),
};
